export const FILE_TYPE_TO_PDF = ["pdf","jpg","jpeg","png","csv", "doc", "docx", "odp", "ods", "odt", "pot", "potm", "potx", "pps", "ppsx", "ppsxm", "ppt", "pptm", "pptx", "rtf", "xls", "xlsx"];

export const MS_GRAPH_EXT_TO_PDF = ["csv", "doc", "docx", "odp", "ods", "odt", "pot", "potm", "potx", "pps", "ppsx", "ppsxm", "ppt", "pptm", "pptx", "rtf", "xls", "xlsx"];

export const IMAGE_EXT_TO_PDF = ["png", "jpg", "jpeg"]